import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import OrderButtons from 'common/components/OrderButtons';
import AnswerTypeInput from './AnswerTypeInput';
import TemplateTypeInput from './TemplateTypeInput';

class QuestionHeader extends React.Component {
  static propTypes = {
    question: PropTypes.object.isRequired,
    questionCount: PropTypes.number.isRequired,
    update: PropTypes.func.isRequired,
    moveUp: PropTypes.func.isRequired,
    moveDown: PropTypes.func.isRequired,
    remove: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.onTitleChange = this.onTitleChange.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.onAnswerTypeChange = this.onAnswerTypeChange.bind(this);
  }

  onTitleChange(evt) {
    this.props.update({
      title: evt.target.value,
    });
  }

  onTemplateChange(template) {
    this.props.update({
      template,
    });
  }

  onAnswerTypeChange(value) {
    this.props.update({
      multi_choice: value,
    });
  }

  render() {
    const { question, questionCount, moveUp, moveDown, remove } = this.props;

    return (
      <div className="ui clearing segment">
        <div className="ui grid">
          <div className="twelve wide column">
            <div className="ui form">
              <div className="three fields">
                <div className="field">
                  <div className="ui input">
                    <input
                      type="text"
                      value={question.title}
                      onChange={this.onTitleChange}
                    />
                  </div>
                </div>
                <div className="field">
                  <AnswerTypeInput
                    value={question.multi_choice}
                    onChange={this.onAnswerTypeChange}
                  />
                </div>
                <div className="field">
                  <TemplateTypeInput
                    value={question.template}
                    onChange={this.onTemplateChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="right floated two wide column">
            <button
              className="ui right floated compact negative icon button"
              onClick={remove}
            >
              <i className="trash outline icon" />
            </button>
            <OrderButtons
              moveUp={moveUp}
              canMoveUp={question.order > 1}
              moveDown={moveDown}
              canMoveDown={question.order < questionCount}
              mode="horizontal"
              className="right floated"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default pure(QuestionHeader);



// WEBPACK FOOTER //
// ./src/modules/funnel/components/detail/questions/QuestionHeader.js